import { css } from '@emotion/react';
import { isProd } from '@artica/constants';

export default css`
  @font-face {
    font-family: 'Söhne Breit';
    font-weight: bold;
    src: ${isProd ? `local('Söhne Breit'),` : ''} url('/fonts/soehne/soehne-breit-kraftig.woff2') format('woff');
  }
`;